module.exports = __webpack_public_path__ + "img/huellita.c512e4ae.png";